exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-group-custom[data-v-1325a33c]  .el-radio-button__inner{padding-left:12px;padding-right:12px}\n", ""]);

// exports
